const FEATURES = [
  { emoji: '\uD83D\uDD0D', title: 'Smart drug search', desc: 'RxNorm-powered autocomplete recognizes brand and generic names.' },
  { emoji: '\uD83E\uDDE0', title: 'AI interaction analysis', desc: 'Grounded in openFDA labels and reasoned by Claude, with sources cited on every result.' },
  { emoji: '\uD83D\uDEE1\uFE0F', title: 'Daily safety score', desc: 'Single 0\u2013100 number across your entire med list, updated automatically.' },
  { emoji: '\u23F0', title: 'Scheduled reminders', desc: 'Never miss a dose; PRN tracking for as-needed medications.' },
  { emoji: '\uD83D\uDCC8', title: 'Adherence history', desc: 'See your last 30 days at a glance, with day-by-day timeline.' },
  { emoji: '\uD83D\uDCCB', title: 'Doctor-ready summary', desc: 'Share a clean Markdown summary in one tap.' },
];

export default function FeatureGrid() {
  return (
    <section id="features" className="py-16 md:py-20 scroll-mt-20" style={{ backgroundColor: '#FBF6EF' }} data-testid="landing-features">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-12" style={{ color: '#5B2D1F' }}>
          Everything you need
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={f.title}
              className="rounded-2xl border p-6"
              style={{ backgroundColor: '#FFFFFF', borderColor: '#D7E2E8' }}
              data-testid={`landing-feature-${i}`}
            >
              <span className="text-3xl block mb-3" role="img" aria-hidden="true">{f.emoji}</span>
              <h3 className="text-lg font-extrabold mb-1" style={{ color: '#5B2D1F' }}>{f.title}</h3>
              <p className="text-sm leading-relaxed" style={{ color: '#6B4A3A' }}>{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
